import { render, staticRenderFns } from "./ModalVideos.vue?vue&type=template&id=65c68c69&"
import script from "./ModalVideos.vue?vue&type=script&lang=js&"
export * from "./ModalVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports